module.exports = __webpack_public_path__ + "static/description-1-f13cb936baf8509f7dc3cd230e000abc.png";